var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog modal-lg" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [_vm._v(" ")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { "aria-label": "Close", type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c(
          "form",
          {
            staticClass: "form-horizontal",
            on: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c("div", { staticClass: "mb-4 row" }, [
              _c("label", { staticClass: "col-sm-4 col-lg-3 form-label" }, [
                _vm._v("Image"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-8 col-lg-9" },
                [
                  _c(_setup.ImageSelection, {
                    attrs: {
                      "file-id": _setup.fileId,
                      "on-change": _setup.onChange,
                      "form-id": _setup.props.options.formId,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-4 row" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-lg-3 form-label",
                  attrs: { for: "altText" },
                },
                [_vm._v("Alternative text")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8 col-lg-9" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _setup.formData.altText,
                      expression: "formData.altText",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "altText", disabled: !_setup.fileId },
                  domProps: { value: _setup.formData.altText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_setup.formData, "altText", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-4 row" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-lg-3 form-label",
                  attrs: { for: "title" },
                },
                [_vm._v("Title")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8 col-lg-9" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _setup.formData.title,
                      expression: "formData.title",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "title", disabled: !_setup.fileId },
                  domProps: { value: _setup.formData.title },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_setup.formData, "title", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-4 row" }, [
              _c("label", { staticClass: "col-sm-4 col-lg-3 form-label" }, [
                _vm._v("Alignment"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8 col-lg-9" }, [
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      class: { active: _setup.align === false },
                      attrs: { disabled: !_setup.fileId, type: "button" },
                      on: {
                        click: function ($event) {
                          _setup.align = false
                        },
                      },
                    },
                    [_vm._v("none")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      class: { active: _setup.align === "left" },
                      attrs: { disabled: !_setup.fileId, type: "button" },
                      on: {
                        click: function ($event) {
                          _setup.align = "left"
                        },
                      },
                    },
                    [_c("i", { staticClass: "bi-align-start" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      class: { active: _setup.align === "center" },
                      attrs: { disabled: !_setup.fileId, type: "button" },
                      on: {
                        click: function ($event) {
                          _setup.align = "center"
                        },
                      },
                    },
                    [_c("i", { staticClass: "bi-align-center" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      class: { active: _setup.align === "right" },
                      attrs: { disabled: !_setup.fileId, type: "button" },
                      on: {
                        click: function ($event) {
                          _setup.align = "right"
                        },
                      },
                    },
                    [_c("i", { staticClass: "bi-align-end" })]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-4 row" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-lg-3 form-label",
                  attrs: { for: "width" },
                },
                [_vm._v("Dimensions")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-8 col-lg-9 d-flex align-items-center" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.formData.width,
                        expression: "formData.width",
                      },
                    ],
                    staticClass: "form-control me-1",
                    attrs: {
                      id: "width",
                      disabled: !_setup.fileId,
                      placeholder: "w",
                      type: "number",
                    },
                    domProps: { value: _setup.formData.width },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _setup.formData,
                            "width",
                            $event.target.value
                          )
                        },
                        _setup.setWidth,
                      ],
                    },
                  }),
                  _vm._v(
                    "\n                        x\n                        "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.formData.height,
                        expression: "formData.height",
                      },
                    ],
                    staticClass: "form-control ms-1",
                    attrs: {
                      id: "height",
                      disabled: !_setup.fileId,
                      placeholder: "h",
                      type: "number",
                    },
                    domProps: { value: _setup.formData.height },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _setup.formData,
                            "height",
                            $event.target.value
                          )
                        },
                        _setup.setHeight,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ms-1 btn btn-sm btn-light",
                      attrs: { disabled: !_setup.fileId, type: "button" },
                      on: {
                        click: function ($event) {
                          _setup.lockRatio = !_setup.lockRatio
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "bi",
                        class: _setup.lockRatio ? "bi-lock" : "bi-unlock",
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ms-1 btn btn-sm btn-light",
                      attrs: { disabled: !_setup.fileId, type: "button" },
                      on: { click: _setup.refreshDimensions },
                    },
                    [_c("i", { staticClass: "bi-arrow-clockwise" })]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-4 row" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-lg-3 form-label",
                  attrs: { for: "sizes" },
                },
                [_vm._v("Sizes")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8 col-lg-9" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _setup.formData.sizes,
                      expression: "formData.sizes",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "sizes", disabled: !_setup.fileId },
                  domProps: { value: _setup.formData.sizes },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_setup.formData, "sizes", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }